export const callFail = (callback, data) => {
    typeof callback == "function" &&
        callback(data || "Internal Server Error", null);
};

export const callSuccess = (callback, data) => {
    typeof callback == "function" && callback(false, data);
};
